import moment, { Moment, MomentInput } from 'moment'

/** Join Call Now is offered from 15 minutes before start through the event end. */
export const EVENT_JOIN_WINDOW_MINUTES = 15

export type EventJoinWindow = {
  canBeJoined: boolean
  endsAt: Moment | null
  isFuture: boolean
  isHappeningNow: boolean
  isPast: boolean
  isStartingSoon: boolean
  startsAt: Moment | null
}

export function isAirtableRecordId(value?: string | null): boolean {
  return /^rec[a-zA-Z0-9]+$/.test(value || '')
}

export function getJoinEventPath(
  event?: {
    eventAirtableRecordIdentifier?: string | null
    groupEventId?: string | null
  } | null
): string | null {
  const id = event?.eventAirtableRecordIdentifier || event?.groupEventId
  return id ? `/join-event/${id}` : null
}

export function getEventJoinWindow(
  startsAt?: MomentInput | null,
  endsAt?: MomentInput | null,
  nowInput?: MomentInput
): EventJoinWindow {
  const now = moment(nowInput)
  const start = startsAt ? moment(startsAt) : null
  const end = endsAt ? moment(endsAt) : null
  const validStart = start && start.isValid() ? start : null
  const validEnd = end && end.isValid() ? end : null

  if (!validStart) {
    return {
      canBeJoined: false,
      endsAt: validEnd,
      isFuture: false,
      isHappeningNow: false,
      isPast: false,
      isStartingSoon: false,
      startsAt: validStart,
    }
  }

  const isFuture = now.isBefore(validStart)
  const isPast = validEnd ? now.isAfter(validEnd) : now.isAfter(validStart.clone().endOf('day'))
  const isHappeningNow = !isFuture && !isPast
  const canBeJoined =
    (isFuture || isHappeningNow) &&
    now.clone().add(EVENT_JOIN_WINDOW_MINUTES, 'minutes').isSameOrAfter(validStart)

  return {
    canBeJoined,
    endsAt: validEnd,
    isFuture,
    isHappeningNow,
    isPast,
    isStartingSoon: canBeJoined && isFuture,
    startsAt: validStart,
  }
}
